import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';
import { CADatePipe } from 'src/core/pipes/ca-date.pipe';
import { take } from 'rxjs';

@Component({
  selector: 'ca-statistical-comparison-result-failed-notification',
  templateUrl: './statistical-comparison-result-failed-notification.component.html',
  styleUrls: ['./statistical-comparison-result-failed-notification.component.scss'],
  standalone: false,
})
@NotificationType(
  'StatisticalComparisonResultFailedNotification',
  StatisticalComparisonResultFailedNotificationComponent,
)
export class StatisticalComparisonResultFailedNotificationComponent {
  data: NotificationDto;

  get payloadData(): any {
    return JSON.parse(this.data?.payload);
  }

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {}

  navigate() {
    this.notificationService.getReadStatus(this.data.id).subscribe(result => {
      if (!result) {
        this.notificationService.markAsRead(this.data.id).subscribe();
      }
    });
  }

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector,
    caDatePipe: CADatePipe,
    router: Router,
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant(
      parsedPayload.comparisonEnabled
        ? 'Analysis::StatisticComparison:Result:Comparison:FailedNotification'
        : 'Analysis::StatisticComparison:Result:Analysis:FailedNotification',
    );

    var toastrId = toastr.error(message);

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap
      .pipe(take(1))
      .subscribe(() => this.toasterClickedHandler(notificationService, notificationId));
  }

  static toasterClickedHandler(notificationService: NotificationService, notificationId: string) {
    notificationService.markAsRead(notificationId).subscribe();
  }
}
